import SearchBar from "components/BaseWidgets/search";
import Tabs from "components/BaseWidgets/tab";
import BlogBannerCard from "components/Cards/BlogBannerCard";
import BlogCard from "components/Cards/BlogCard";
import Skeleton from "components/BaseWidgets/skeleton";
import EmptyState from "components/BaseWidgets/emptyState";
import "./style.scss";
import { useBlogList } from "hooks/api/useHome";
import { useState } from "react";

export default function Blog() {
  const [activeTab, setActiveTab] = useState("1");
  const [searchKey, setSearchKey] = useState("");

  const tabRequestTypes = {
    1: 1, // Latest
    2: 2, // Trending
    3: 3, // Saved
    4: 4, // Liked
  };

  const { data: blogs, isLoading: isblogLoading } = useBlogList({
    see_all: true,
    request_type: tabRequestTypes[activeTab],
    search_key: searchKey,
  });

  const handleSearch = (value) => {
    setSearchKey(value);
  };

  const renderTabContent = (label) => (
    <div className="blog-list">
      {isblogLoading ? (
        Array.from({ length: 4 }).map((_, index) => (
          <Skeleton key={index} label={false} height={200} />
        ))
      ) : blogs?.blog_data?.length ? (
        blogs.blog_data.map((blog) => (
          <BlogCard
            key={blog.id}
            blog={blog}
            requestType={tabRequestTypes[activeTab]}
          />
        ))
      ) : (
        <EmptyState
          message={`No ${label} blogs found!`}
          className="overview-empty"
        />
      )}
    </div>
  );

  const tabConfig = [
    { key: "1", label: "Latest" },
    { key: "2", label: "Trending" },
    { key: "3", label: "Saved" },
    { key: "4", label: "Liked" },
  ];

  const tabItems = tabConfig.map(({ key, label }) => ({
    key,
    label,
    children: renderTabContent(label),
  }));

  const bannerSlides = blogs?.blog_data?.map((blog) => ({
    bannerImage: blog.image,
    blogCardHead: blog.head,
    blogCardContent: blog.body,
    userImage: blog.blog_written_by_image,
    quotedName: blog.blog_written_by_name,
    quotedTime: blog.time,
  }));

  return (
    <div className="container">
      <div className="blog-container">
        <h1 className="blog-title-main font-title-xxl">Our blogs</h1>
        <p className="blog-desc font-title-normal fw-500">
          Explore our blogs to enhance your matchmaking experience.
        </p>

        {isblogLoading ? (
          <Skeleton label={false} height={300} />
        ) : blogs?.blog_data?.length ? (
          <BlogBannerCard slides={bannerSlides} slideInterval={4000} />
        ) : (
          <EmptyState
            message="No featured blogs available!"
            className="overview-empty"
          />
        )}

        <div className="search-wrap">
          <SearchBar onSearch={handleSearch} value={searchKey} />
        </div>

        <Tabs
          variant="secondary"
          items={tabItems}
          onChange={(key) => setActiveTab(key)}
        />
      </div>
    </div>
  );
}
